import { basicAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const authelia = defineConnector({
  identifier: "authelia",
  name: "Authelia",
  tagLine: "Authentication server",
  logo,
  protocol: "http",
  tags: ["identity"],
  defaultUrlPattern: ({ baseUrl }) => domainToRegex(baseUrl),
  auth: (app) =>
    basicAuth({
      username: app.config.username,
      password: app.secret.password,
    }),
  steps: [
    {
      title: "Configure your Authelia endpoint",
      items: [
        {
          kind: "markdown",
          content:
            "Enter the URL of your Authelia server and provide basic auth credentials if required.",
        },
      ],
    },
    {
      title: "Enter your Authelia details",
      items: [
        {
          kind: "baseUrl",
          label: "Authelia URL",
          required: true,
          placeholder: "https://auth.example.com",
          target: { kind: "configuration", field: "baseUrl" },
          helperText: "The base URL of your Authelia server.",
        },
        {
          kind: "input",
          label: "Username",
          required: false,
          target: { kind: "configuration", field: "username" },
          helperText: "For API authentication.",
        },
        {
          kind: "input",
          label: "Password",
          required: false,
          target: { kind: "secrets", field: "password" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ baseUrl }) => `${baseUrl}/api/health`,
  },
  publicEnvVars: ({ baseUrl }) => ({
    AUTHELIA_URL: baseUrl || "",
  }),
});
